import { ActiveWorkflowsBySpace } from "./ActiveWorkflowsBySpace";
import { AutofixAutotunePanel } from "./AutofixAutotunePanel";
import { DuplicateWorkflowsPanel } from "./DuplicateWorkflowsPanel";
import { ExecutionVolumeBySpace } from "./ExecutionVolumeBySpace";
import { FailingWorkflowsPanel } from "./FailingWorkflowsPanel";
import { MonitoringLayout } from "./MonitoringLayout";
import { RouteAuthPanel } from "./RouteAuthPanel";
import { useFeatureFlag } from "../../hooks/useFeatureFlag";
import { useHasAccess } from "../../hooks/useHasAccess";
import { StorageBySpace } from "./StorageBySpace";
import { TinesUnitsPanel } from "./TinesUnitsPanel";
import { WorkflowDependenciesPanel } from "./WorkflowDependenciesPanel";
import {
  SideStack,
  SideStackPair,
  WorkflowsGrid,
  WorkflowsShell,
} from "./workflowsLayout";

export function Workflows() {
  const tinesUnitsEnabled = useFeatureFlag("tines-units");
  // The units gauge mixes per-space stats with tenant-wide network usage, so
  // it only renders for viewers whose reads cover every space — otherwise the
  // inputs would cover different subsets and the total would be misleading.
  const canReadAllSpaces = useHasAccess("tenant:spaces_read");
  return (
    <MonitoringLayout>
      <WorkflowsShell>
        {tinesUnitsEnabled && canReadAllSpaces && <TinesUnitsPanel />}
        <WorkflowsGrid>
          <ActiveWorkflowsBySpace />
          <ExecutionVolumeBySpace />
          <StorageBySpace />
          <RouteAuthPanel />
          <SideStack>
            <FailingWorkflowsPanel />
            <DuplicateWorkflowsPanel />
            <SideStackPair>
              <AutofixAutotunePanel />
              <WorkflowDependenciesPanel />
            </SideStackPair>
          </SideStack>
        </WorkflowsGrid>
      </WorkflowsShell>
    </MonitoringLayout>
  );
}
